import React, { useCallback } from 'react';
import styles from './RatingInput.module.scss';

const RatingInput = (props) => {
    const { className, onChange, value, maxRating, checkedColor, defaultColor, disabled = false } = props,
        classes = ['RatingInput', className, maxRating > 5 ? 'small-bullets' : '', disabled ? 'disabled' : ''];

    const handleChange = useCallback(
        (option) => {
            if (!onChange) return;
            if (disabled) return;

            onChange(option);
        },
        [onChange]
    );

    return (
        <table className={classes.join(' ')}>
            <tbody>
                <tr>
                    {_.range(1, maxRating + 1).map((option) => {
                        let isChecked = option <= value;
                        return (
                            <td key={option} style={{ width: (100 / maxRating).toString() + '%' }}>
                                <button
                                    type="button"
                                    className={[isChecked ? 'checked' : null, onChange ? 'clickable' : null].join(' ')}
                                    style={{
                                        backgroundColor: isChecked ? checkedColor : defaultColor,
                                        borderColor: checkedColor,
                                    }}
                                    onClick={() => handleChange(option)}></button>
                                <label className={styles.label}>{option}</label>
                            </td>
                        );
                    })}
                </tr>
            </tbody>
        </table>
    );
};

export default RatingInput;
